import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//基础信息相关API

const certificateManagement = {
    major: {
        queryList: config => createAPI('/skillRecognition/zsgl/queryList', 'post', config),
        initCombo: config => createAPI('/skillRecognition/zsgl/initCombo', 'post', config),
        save: config => createAPI('/skillRecognition/zsgl/save', 'post', config),
        deleteById: config => createAPI('/skillRecognition/zsgl/del', 'post', config),
        releaseRecById: config => createAPI('/skillRecognition/zsgl/releaseRecById', 'post', config),
        queryById: config => createAPI('/skillRecognition/zsgl/queryById', 'post', config),
        queryZskc: config => createAPI('/skillRecognition/zsgl/queryZskc', 'post', config),
    },
};

export default certificateManagement;



// WEBPACK FOOTER //
// ./src/api/modules/certificateManagement.js